import React from "react";
import { News } from "..//../components/news-component/News";
import "./blog.styles.css";

export const Blog = () => {
  return (
    <div className="blog-page">
      <News />
    </div>
  );
};
